import type { BaseLogParam } from '../types';

/**
 * Computes the metric key based on the provided parameters.
 *
 * @param metricsName - The name of the metric.
 * @param dimensions - The dimensions associated with the metric.
 * @param prefixes - Optional prefixes to be added to the metric key.
 * @returns The computed metric key.
 */
export const computeMetricKey = ({
  metricsName,
  dimensions,
  prefixes = [],
}: BaseLogParam & { prefixes?: string[] }): string => {
  const metricNameFragments = [...prefixes];
  metricNameFragments.push(metricsName);
  if (dimensions) {
    // sort the dimension keys to get stable key
    Object.keys(dimensions)
      .sort()
      .forEach((key: string) => {
        const value: string = dimensions[key];
        metricNameFragments.push(key, value);
      });
  }
  return metricNameFragments.join('.');
};
